// @owners { team: patient-health }
import React from 'react';
import { type Medication } from '~shared/features/my-meds/types';
import { type Transfer, type User } from '~shared/types/clients';
import MedListActive from './MedListActive';
import MedListInactive from './MedListInactive';
import { Tab, TabList, TabPanel, Tabs } from '~web/components/Tab';

const ACTIVE_TAB_INDEX = 0;
const INACTIVE_TAB_INDEX = 1;

type Props = {
  readonly active: Medication[];
  readonly familyMembers: User[];
  readonly hasFamily: boolean;
  readonly inactive: Medication[];
  readonly initialRxNumber: string | null | undefined;
  readonly needsAttention: Medication[];
  readonly transfers: Transfer[];
  readonly currentUser: User;
};

type State = {
  defaultIndex: number;
};

export default class MedList extends React.PureComponent<Props, State> {
  static defaultProps = {
    initialRxNumber: null,
  };

  constructor(props: Props) {
    super(props);
    const { inactive, initialRxNumber } = props;

    let defaultIndex = ACTIVE_TAB_INDEX;

    if (initialRxNumber) {
      for (const medication of inactive) {
        if (medication?.prescriptions?.some?.((p) => p.rx_number === initialRxNumber)) {
          defaultIndex = INACTIVE_TAB_INDEX;
          break;
        }
      }
    }

    this.state = {
      defaultIndex,
    };
  }

  render() {
    const { active, familyMembers, hasFamily, inactive, initialRxNumber, needsAttention, transfers, currentUser } =
      this.props;
    const { defaultIndex } = this.state;

    return (
      <Tabs defaultIndex={defaultIndex}>
        <TabList>
          <Tab>ACTIVE</Tab>
          <Tab>INACTIVE</Tab>
        </TabList>
        <TabPanel>
          <MedListActive
            active={active}
            familyMembers={familyMembers}
            hasFamily={hasFamily}
            initialRxNumber={initialRxNumber}
            needsAttention={needsAttention}
            transfers={transfers}
            currentUser={currentUser}
          />
        </TabPanel>
        <TabPanel>
          <MedListInactive
            familyMembers={familyMembers}
            hasFamily={hasFamily}
            inactive={inactive}
            initialRxNumber={initialRxNumber}
          />
        </TabPanel>
      </Tabs>
    );
  }
}
